import type { EegModalProps } from './interfaces';
import Modal from '../Modal/Modal';

const EegModal = (props: EegModalProps) => {
  return <Modal {...props} />;
};

export default EegModal;
